module.exports = __webpack_public_path__ + "img/bak3.51520b11.jpg";